/**
 * Directives for module mwApp.settings
 */

/**
 * disallowValues directive <br>
 *
 * @class disallowValues
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc directive
 * @name mwApp/settings.directive:disallowValues
 *
 * @example
 * <form name="form">
 *     Name: <input name="name" ng-model="name" disallowValues="['Admin']"><br>
 *     <div class="text-danger" ng-messages="form.name.$error" ng-show="form.name.$touched">
 *         <p ng-message="disallowValues">You cannot use this value</p>
 *     </div>
 * </form>
 */
export function disallowValues () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      values: '=disallowValues'
    },
    link: function (scope, _element, _attributes, ngModel) {
      let values = Array.isArray(scope.values) ? scope.values : [scope.values]
      ngModel.$validators.disallowValues = (modelValue) =>
        !modelValue || values.indexOf(modelValue) === -1
    }
  }
}
